var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-1",class:[_vm.color, _vm.dark ? 'white--text' : 'black--text'],attrs:{"app":""}},[_vm._t("left"),_c('v-spacer'),_vm._t("center"),_c('v-spacer'),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }